'use client';

import MetricLineChart from '../MetricLineChart';
import MetricGauge from '../MetricGauge';
import MetricBarChart from '../MetricBarChart';

// Sample data: Change failure rate trend
const trendData = [
  { name: 'Month 1', cfr: 28 },
  { name: 'Month 2', cfr: 25 },
  { name: 'Month 3', cfr: 22 },
  { name: 'Month 4', cfr: 18 },
  { name: 'Month 5', cfr: 15 },
  { name: 'Month 6', cfr: 12 },
];

// Sample data: Failure types breakdown
const failureTypesData = [
  { name: 'Configuration', count: 5, percentage: 42 },
  { name: 'Code Bugs', count: 3, percentage: 25 },
  { name: 'DB Migration', count: 2, percentage: 17 },
  { name: 'Infrastructure', count: 1, percentage: 8 },
  { name: 'Dependencies', count: 1, percentage: 8 },
];

export function ChangeFailureRateTrend() {
  return (
    <div className="my-8">
      <h3 className="text-xl font-semibold text-accent mb-4">📉 Change Failure Rate Improvement</h3>
      <MetricLineChart
        data={trendData}
        lines={[
          { dataKey: 'cfr', name: 'Change Failure Rate (%)', color: '#E89841' },
        ]}
        xAxisLabel="Month"
        yAxisLabel="Failure Rate (%)"
        targetLine={15}
        height={350}
      />
      <p className="text-sm text-foreground-secondary mt-2">
        Sample data showing improvement from 28% to 12% over 6 months through better testing and
        progressive rollouts. The green line represents Elite threshold (&lt; 15%).
      </p>
    </div>
  );
}

export function ChangeFailureRateGauge() {
  return (
    <div className="my-8">
      <h3 className="text-xl font-semibold text-accent mb-4">🎯 Current Performance</h3>
      <MetricGauge
        value={12}
        max={100}
        label="Change Failure Rate"
        unit="%"
        ranges={[
          { min: 0, max: 15, color: '#6FCF97', label: 'Elite' },
          { min: 15, max: 30, color: '#4A90E2', label: 'High' },
          { min: 30, max: 45, color: '#F2C94C', label: 'Medium' },
          { min: 45, max: 100, color: '#EB5757', label: 'Low' },
        ]}
      />
      <p className="text-sm text-foreground-secondary mt-2">
        Current CFR of 12% places the team in the Elite category. Continue monitoring and
        addressing root causes to maintain this level.
      </p>
    </div>
  );
}

export function FailureTypesChart() {
  return (
    <div className="my-8">
      <h3 className="text-xl font-semibold text-accent mb-4">🔍 Failure Root Causes</h3>
      <MetricBarChart
        data={failureTypesData}
        bars={[
          { dataKey: 'count', name: 'Number of Failures', color: '#E89841' },
        ]}
        xAxisLabel="Failure Type"
        yAxisLabel="Count"
        height={300}
      />
      <p className="text-sm text-foreground-secondary mt-2">
        Configuration errors are the leading cause (42%). Focus on configuration validation
        and testing to reduce failures further.
      </p>
    </div>
  );
}
